export default "__VITE_ASSET__D$1QTOxY__"